import React, { useEffect, useState } from 'react'
import { useAuth } from '../../../modules/auth'
import { getActiveUsersByInstanceId } from '../../../modules/user/components/users-list/core/_requests'
import { User } from '../../../modules/user/components/users-list/core/_models'
import { ID } from '../../../../_metronic/helpers'
import { useIntl } from 'react-intl'
import Select, { SingleValue } from 'react-select'

interface UserFilterProps {
  selectedUserId: number | null
  onUserChange: (userId: number | null) => void
  compact?: boolean // Nova prop para controlar se deve usar altura compacta
}

type UserOption = {
  value: string
  label: string
}

const UserFilter: React.FC<UserFilterProps> = ({ selectedUserId, onUserChange, compact = false }) => {
  const { currentUser } = useAuth()
  const [users, setUsers] = useState<User[]>([])
  const [selectedUser, setSelectedUser] = useState<UserOption | null>(null)
  const intl = useIntl()

  // Verificar se o usuário é administrador ou administrador+gerente
  const isAuthorized = true // Removendo a verificação para garantir que o filtro seja exibido

  useEffect(() => {
    if (isAuthorized && currentUser?.instance_id) {
      // Buscar usuários ativos da mesma instância
      getActiveUsersByInstanceId(currentUser.instance_id)
        .then((response) => {
          if (response && response.data) {
            setUsers(response.data)
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar usuários:', error)
        })
    }
  }, [currentUser, isAuthorized])

  // Definir o usuário logado como padrão apenas na primeira renderização
  useEffect(() => {
    if (currentUser?.id && selectedUserId === null) {
      onUserChange(Number(currentUser.id))
    }
  }, [currentUser, onUserChange, selectedUserId])

  // Sincronizar selectedUser com selectedUserId
  useEffect(() => {
    if (selectedUserId && users.length > 0) {
      const currentUser = users.find(user => user.id === selectedUserId)
      if (currentUser) {
        setSelectedUser({
          value: currentUser.id?.toString() || '',
          label: currentUser.name || ''
        })
      }
    } else {
      setSelectedUser(null)
    }
  }, [selectedUserId, users])

  const getUserOptions = (): UserOption[] => {
    return users.map(user => ({
      value: user.id?.toString() || '',
      label: user.name || ''
    }))
  }

  const handleUserChange = (selectedOption: SingleValue<UserOption>) => {
    if (selectedOption) {
      setSelectedUser(selectedOption)
      onUserChange(Number(selectedOption.value))
    } else {
      setSelectedUser(null)
      onUserChange(null)
    }
  }

  // Se o usuário não for autorizado, não renderizar o componente
  if (!isAuthorized) {
    return null
  }

  return (
    <div className={compact ? 'user-filter-compact' : 'user-filter-normal'}>
      <Select
        value={selectedUser}
        onChange={handleUserChange}
        options={getUserOptions()}
        placeholder="Filtrar por usuário"
        isClearable
        isSearchable
        className="react-select-container"
        classNamePrefix="react-select"
        classNames={{
          control: (state) =>
            compact
              ? (state.isFocused
                  ? 'form-control form-control-solid dash-select-control-focused user-filter-control-compact'
                  : 'form-control form-control-solid user-filter-control-compact')
              : (state.isFocused
                  ? 'form-control form-control-solid dash-select-control-focused'
                  : 'form-control form-control-solid'),
          placeholder: () => 'text-muted',
          input: () => 'text-dark',
          singleValue: () => 'text-dark',
          menu: () => 'bg-body',
          option: (state) =>
            state.isSelected
              ? 'dash-select-option-selected'
              : state.isFocused
                ? 'dash-select-option-focused text-dark'
                : 'text-dark'
        }}
      />
    </div>
  )
}

export { UserFilter }